import React, { useState } from 'react'
import {
    Button,
    Box,
    Modal,
    Typography,
    IconButton,
    Avatar,
    Grid,
    TextField,
} from '@mui/material'
import { CloseOutlined, Image } from '@mui/icons-material'
import moment from 'moment'
import { formatTime } from '../../lib/time'

const ViewQuestionModal = (props: any) => {
    var { data, dOpen } = props
    const [open, setOpen] = useState(dOpen ? true : false)

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    if (!data) return <div></div>
    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    padding: '1.5px 12px',
                    textTransform: 'capitalize',
                    borderRadius: 2,
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: '#F0845D',
                        boxShadow: 'none',
                    },
                    minWidth: 0,
                    fontSize: 13,
                }}
                variant='contained'
                color='primary'>
                View
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='simple-modal-title'
                aria-describedby='simple-modal-description'>
                <Box sx={modalStyle}>
                    <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'>
                        <Typography id='simple-modal-title' variant='h5'>
                            Question Details
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseOutlined />
                        </IconButton>
                    </Box>
                    <br />
                    <Box
                        style={{
                            padding: '10px 0',
                            flexDirection: 'row',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                        }}>
                        <Typography sx={{ textWrap: "nowrap", fontWeight: "bold" }}>Question Title:</Typography>
                        <Box
                         component={TextField} 
                         multiline
                         sx={{
                            height: "100%",
                            maxHeight: "50px",
                            overflow: "auto",
                            width: "100%",
                            ml: 1,
                            textWrap: "wrap",
                            '& :hover':{
                                cursor:"default"
                            }
                           }}                           
                           variant="standard"
                           value={data.questionText}
                           InputProps={{readOnly: true,disableUnderline: true}}
                            />
                    </Box>
                    <Box
                        style={{
                            padding: '10px 0',
                            flexDirection: 'row',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                        }}>
                        <strong>Question Type:</strong>
                        <Typography sx={{ml:1}}>
                            {data?.questionType ?? '----'}
                        </Typography>
                    </Box>                    
                    <Box
                        style={{
                            padding: '10px 0',
                            flexDirection: 'row',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                        }}>
                        <Typography sx={{ textWrap: "nowrap", fontWeight: "bold" }}>Correct Answer:</Typography>
                        <Box
                         component={TextField} 
                         multiline
                         sx={{
                            height: "100%",
                            maxHeight: "50px",
                            overflow: "auto",
                            width: "100%",
                            ml: 1,
                            textWrap: "wrap",
                            '& :hover':{
                                cursor:"default"
                            }
                           }}                           
                           variant="standard"
                           value={data.questionType === 'Yes/No' ?
                                 (data.correctAnswer === 'true' ? 'Yes' : 'No')
                                  :
                                (data.correctAnswer)}
                           InputProps={{readOnly: true,disableUnderline: true}}                          
                        />                        
                    </Box>
                    <Box
                        style={{
                            padding: '10px 0',
                            flexDirection: 'row',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                        }}>
                            <strong>isVisible:</strong>
                        <Typography sx={{ml:1}}>
                            {data.isVisible === true ? 'Yes' : 'No'}
                        </Typography>
                    </Box>
                    <Box
                        style={{
                            padding: '10px 0',
                            flexDirection: 'row',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                        }}>
                            <strong>isRequired:</strong>
                        <Typography sx={{ml:1}}>
                            {data.isRequired === true ? 'Yes' : 'No'}
                        </Typography>
                    </Box>

                </Box>
            </Modal>
        </>
    )
}

export default ViewQuestionModal

// Styling for the modal
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width:"100%",
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
    outline: 'none',
    maxWidth:"700px"
}